// extracted by mini-css-extract-plugin
export var addressItem = "carnet-adresse-module--address-item--f887f";
export var addressItemAddress = "carnet-adresse-module--address-item-address--fa228";
export var addressItemContacts = "carnet-adresse-module--address-item-contacts--9b5ee";
export var addressItemMail = "carnet-adresse-module--address-item-mail--9e10b";
export var addressItemMailMobile = "carnet-adresse-module--address-item-mail-mobile--2d1bb";
export var addressItemName = "carnet-adresse-module--address-item-name--eb543";
export var addressItemTel = "carnet-adresse-module--address-item-tel--c36a4";
export var addressItemTitle = "carnet-adresse-module--address-item-title--aaefe";
export var addressItemTooltip = "carnet-adresse-module--address-item-tooltip--df30f";
export var addressItemTooltipMobile = "carnet-adresse-module--address-item-tooltip-mobile--e73b2";
export var addressMore = "carnet-adresse-module--address-more--a22ba";
export var addressesContainer = "carnet-adresse-module--addresses-container--5bdc6";
export var addressesDescription = "carnet-adresse-module--addresses-description--8ad1a";
export var allAddresses = "carnet-adresse-module--all-addresses--0f239";
export var editButtonTitle = "carnet-adresse-module--edit-button-title--dad5a";
export var hiddenInfoBulle = "carnet-adresse-module--hidden-info-bulle--640b3";
export var listAddressesContainer = "carnet-adresse-module--list-addresses-container--d3827";
export var listAddressesTitle = "carnet-adresse-module--list-addresses-title--1e8f9";
export var pasteButton = "carnet-adresse-module--paste-button--76763";
export var pasteButtonImg = "carnet-adresse-module--paste-button-img--4ee82";